var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.475 4.16841L9.6 0.406691C9.41631 0.305193 9.20987 0.251953 9 0.251953C8.79013 0.251953 8.58369 0.305193 8.4 0.406691L1.525 4.16997C1.32866 4.2774 1.16477 4.43557 1.05043 4.62796C0.936094 4.82035 0.875508 5.03992 0.875 5.26372V12.7356C0.875508 12.9594 0.936094 13.179 1.05043 13.3714C1.16477 13.5638 1.32866 13.7219 1.525 13.8293L8.4 17.5926C8.58369 17.6941 8.79013 17.7474 9 17.7474C9.20987 17.7474 9.41631 17.6941 9.6 17.5926L16.475 13.8293C16.6713 13.7219 16.8352 13.5638 16.9496 13.3714C17.0639 13.179 17.1245 12.9594 17.125 12.7356V5.2645C17.1249 5.0403 17.0645 4.82025 16.9502 4.62741C16.8358 4.43456 16.6717 4.27603 16.475 4.16841ZM9 1.50044L15.2766 4.93794L9 8.37544L2.72344 4.93794L9 1.50044ZM2.125 6.03169L8.375 9.452V16.1543L2.125 12.7364V6.03169ZM9.625 16.1543V9.45513L15.875 6.03169V12.7333L9.625 16.1543Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.7625a81a91800a5b510dbf5385990103.svg";
export { ForwardRef as ReactComponent };